/*
*
* File JS componente Block Text
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import accordion from 'imComponents/accordion/accordion';

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-text.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockText = () => {
    accordion();
}

export default blockText;

//--------------------------------------------------------------------//